import { useState, useEffect } from 'react'
import { companyService } from '@/features/company/services/company.service'
import type { CompanyMemberDocument } from '@/types'

export function useHireableMembers() {
  const [members, setMembers] = useState<Array<CompanyMemberDocument & { id: string }>>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    companyService
      .getHireableMembers()
      .then(setMembers)
      .catch(() => setMembers([]))
      .finally(() => setLoading(false))
  }, [])

  return { members, loading }
}
